<div *ngIf="isRegFlow">
    <app-step-progress [steps]="steps"></app-step-progress>
</div>
<div class="row align-items-center mb-2">
    <div class="col-md-8">
        <app-page-title [title]="'Products'"></app-page-title>
        <p>
            Please note that there are no refunds or exchanges on Study Materials
            purchased.
        </p>
    </div>
    <div
        class="col-md-4"
        *ngIf="isRegFlow"
    >
        <a
            routerLink="/registration/order-summary"
            class="btn btn-primary "
        >Review Order & Pay</a>
    </div>
</div>

<app-filter-sort-panel *ngIf="brandId === BrandEnum.CELPIP"
    [topPanel]=true
    [brandId]="brandId"
    [filterSortData]="filterSortData"
    (changeFilterSort)="filterSortChangeHandler($event)"
>
</app-filter-sort-panel>

<app-shopping-cart-summary [isRegFlow]="isRegFlow"></app-shopping-cart-summary>

<div *ngFor="let section of filteredProducts">
    <div
        *ngIf="section.products.length>0"
        class="row"
    >
        <div class="col-md-12 mt-3">
            <h5>{{ section.name }}</h5>
            <hr />
        </div>
        <div class="col-md-12">
            <div class="cart">
                <div
                    *ngFor="let product of section.products"
                    class="product-item"
                >
                    <app-product-item
                        [brandId]="brandId"
                        [product]="product"
                        [isRegFlow]="isRegFlow"
                        (addProduct)="addItemToCart($event)"
                    >
                    </app-product-item>
                </div>
            </div>
        </div>
    </div>
</div>

<app-filter-sort-panel *ngIf="brandId === BrandEnum.CELPIP" 
    [topPanel]=false
    [brandId]="brandId"
    [filterSortData]="filterSortData"
    (changeFilterSort)="filterSortChangeHandler($event)"
>
</app-filter-sort-panel>

<div class="row align-items-center">
    <div class="col-md-8 text-center">
        <strong>Please click 'View Shopping Cart' to get to the next step to complete your purchase.</strong>
    </div>
    <div class="col-md-4 text-center p-2">
        <a
            [routerLink]="isRegFlow ? ['/registration/order-summary'] : ['/shopping-cart']"
            class="btn btn-primary"
        >
            View Shopping Cart
        </a>
    </div>
</div>

<app-modal
    #addItemWarning
    title="Note"
    [body]="addItemWarningMesssage"
    (clickPositive)="finalizeAdd()"
    isConfirm="true"
>
</app-modal>
